import axios from "axios";
import axiosRetry from "axios-retry";
import qs from "qs";
import toastr from "toastr";
import * as actions from "./authBoarningTypes";
import errorManage from "../../errorManage";
import messages from "../../messages";
import authBoarningServices from "./authBoarning.services";

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

function verifyUser(){
  return JSON.parse(localStorage.getItem('auth'));
}

export const getUsers = (params) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_AUTH,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.get(`/api/app/User/`, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: data
    // });
    const resp = await authBoarningServices.getUsersBoarning(params);
    // const respRoles = await client.get('/api/app/Group/', {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   }
    // });
    //const respRoles = await authServices.getGroups();
    dispatch({
      type: actions.GET_USERS,
      payload: {
        users: resp.data.data,
        usersLength: resp.data.count,
        //roles: respRoles.data.data
      }
    });
    dispatch({
      type: actions.USER_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(Array.isArray(ex.response.data)){
              ex.response.data.forEach(item => {
                toastr.error(item);
              });
            }else{
              message = ex.response.data.mensaje;
            }
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.USER_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
         type: actions.LOADING_AUTH,
      payload: false
    });
  }
}
